


import { RequestLetterEditController } from './controllers/requestLetterEditController';


export class RequestLetterEditDirective implements angular.IDirective {
    template = require('./templates/requestLetterEdit.html');
    restrict = 'E';
    controller = RequestLetterEditController;
    controllerAs = 'vm';
    bindToController = {
        requestDetailEdit: '='
    };
    scope = {};

    static factory(): angular.IDirectiveFactory {
        return () => new RequestLetterEditDirective();
    }
}

angular.module('deliveryCreate.app').directive('requestLetterEdit', RequestLetterEditDirective.factory());



/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetailEdit/directives/requestLetterEdit/requestLetterEditDirective.ts
 **/